import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { vetInstructionsService } from '../services/apiServices';

export const VET_INSTRUCTION_KEYS = {
  all: ['vet-instructions'] as const,
  lists: () => [...VET_INSTRUCTION_KEYS.all, 'list'] as const,
  list: (params?: any) => [...VET_INSTRUCTION_KEYS.lists(), params] as const,
  details: () => [...VET_INSTRUCTION_KEYS.all, 'detail'] as const,
  detail: (id: number) => [...VET_INSTRUCTION_KEYS.details(), id] as const,
};

export const useVetInstructions = (params?: any) => {
  return useQuery({
    queryKey: VET_INSTRUCTION_KEYS.list(params),
    queryFn: () => vetInstructionsService.getAll(params),
  });
};

export const useVetInstruction = (id: number) => {
  return useQuery({
    queryKey: VET_INSTRUCTION_KEYS.detail(id),
    queryFn: () => vetInstructionsService.getById(id),
    enabled: !!id,
  });
};

export const useCreateVetInstruction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => vetInstructionsService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VET_INSTRUCTION_KEYS.lists() });
    },
  });
};

export const useCompleteVetInstruction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) =>
      vetInstructionsService.complete(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VET_INSTRUCTION_KEYS.all });
    },
  });
};
